import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { setLoaderOptions } from '@loaders.gl/core';
import './index.css';
import './i18n';
import App from './App.tsx';
import { UploadManager } from '@components/UploadManager/uploadManager.tsx';

// Configure loaders.gl to use local workers (must be done before any layers are created)
setLoaderOptions({
  draco: {
    workerUrl: '/workers/draco/draco-worker.js',
    decoderType: 'wasm',
  },
  terrain: {
    workerUrl: '/workers/terrain/terrain-worker.js',
  },
});

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <UploadManager />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
);
